import { Button } from '@octopus-do/octopus-storybook'
import { confirmStateSelector } from '@store/confirmation'
import type React from 'react'
import { useSelector } from 'react-redux'

import css from './styles.module.css'

interface Props {
  cancelButton: React.ReactNode
  confirmCb: () => void
}

export const GeneralConfirm: React.FC<Props> = ({
  cancelButton,
  confirmCb,
}) => {
  const data = useSelector(confirmStateSelector)

  if (!data) {
    return null
  }

  const { title, message, label } = data

  return (
    <div className="System-dialog__inner">
      <div className="System-dialog__title">{title}</div>

      <div className="System-dialog__description">
        <p>{message}</p>
      </div>

      <div className="System-dialog__buttons">
        <Button
          className={css.submit}
          tone="danger"
          size="medium"
          label={label}
          onClick={confirmCb}
        />

        <div className="System-dialog__buttons-item">{cancelButton}</div>
      </div>
    </div>
  )
}
